<template>
  <div class="flex items-center space-x-1 sm:space-x-2">
    <input
      type="color"
      :value="modelValue"
      @change="updateColor"
      :class="inputClass"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  modelValue: string;
}

interface Emits {
  (e: "update:modelValue", value: string): void;
}

defineProps<Props>();

const inputClass = computed(() => {
  return "w-6 h-6 rounded";
});

const emit = defineEmits<Emits>();

const updateColor = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
};
</script>
